import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Sparkles, Users, Video, Trophy, Target } from "lucide-react";
import { GAEventTrack } from "../../utils/hooks/GA_events";

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    "/img/ai-lab/hero_coding.jpg",
    "/img/ai-lab/hero-1.jpg",
    "/img/ai-lab/hero-2.jpg",
    "/img/ai-lab/hero-3.jpg",
  ];

  const slideAlts = [
    "Kids learning coding and programming at Practido Learning Center Panipat",
    "Students building robots in robotics classes at Practido Learning Center",
    "Children working on STEM projects at Practido learning lab",
    "Kids exploring Artificial Intelligence and future technology skills in classroom"
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="section hero hero-gradient-bg" id="hero">
      <div className="container">
        <div className="hero-grid">
          {/* Left Hero Content */}
          <div className="hero-content reveal-triggered fade-up active">
            <div className="badge hero-badge">
              <span>🚀</span> India's Leading AI Education Platform
            </div>
            <h1>AI, Robotics, Coding &<br /><span>Future Skills Classes for Kids</span></h1>
            <div className="hero-supporting-line">Learn. Build. Create. Innovate.</div>
            <p>Hands-on courses in Artificial Intelligence, Robotics, Coding, STEM, Design, Video Editing and Future Skills for students aged 6-18.</p>
            <p>Prepare your child for the future with project-based learning designed to build creativity, problem-solving, innovation and technology skills.</p>

            <div className="hero-buttons">
              <a href="#courses" className="btn primary-btn">
                <Sparkles className="mr-1" size={16} strokeWidth={2.5} />
                Explore Courses
              </a>
              {/* Commented out original registration redirect:
              <Link to="/register/individual?source=ai-lab" className="btn seconday-btn">Book Free Demo</Link>
              */}
              <a
                href="https://wa.me/919560734660"
                target="_blank"
                rel="noopener noreferrer"
                className="btn blue-btn"
                onClick={() => GAEventTrack({ event: "book_free_demo_click", data: { location: "hero" } })}
              >
                Book Free Demo
              </a>
            </div>

            {/* Bottom Left Stats Row */}
            <div className="hero-stats-row">
              <div className="stat-card">
                <div className="stat-icon" style={{ backgroundColor: "rgba(139, 92, 246, 0.08)", color: "var(--accent-purple)" }}>
                  <Users size={18} strokeWidth={2.5} />
                </div>
                <div className="stat-number">20K+</div>
                <div className="stat-label">Students</div>
              </div>

              <div className="stat-card">
                <div className="stat-icon" style={{ backgroundColor: "rgba(59, 130, 246, 0.08)", color: "var(--accent-blue)" }}>
                  <Sparkles size={18} strokeWidth={2.5} />
                </div>
                <div className="stat-number">AI</div>
                <div className="stat-label">Powered Learning</div>
              </div>

              <div className="stat-card">
                <div className="stat-icon" style={{ backgroundColor: "rgba(139, 92, 246, 0.08)", color: "var(--accent-purple)" }}>
                  <Video size={18} strokeWidth={2.5} />
                </div>
                <div className="stat-number">Live</div>
                <div className="stat-label">Classes</div>
              </div>

              <div className="stat-card">
                <div className="stat-icon" style={{ backgroundColor: "rgba(139, 92, 246, 0.08)", color: "var(--accent-purple)" }}>
                  <Trophy size={18} strokeWidth={2.5} />
                </div>
                <div className="stat-number">Project</div>
                <div className="stat-label">Based</div>
              </div>
            </div>
          </div>

          {/* Right Hero Media */}
          <div className="hero-media reveal-triggered scale-in delay-200 active">
            <div className="hero-img-wrap">
              <div className="hero-carousel-track" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                {slides.map((src, index) => (
                  <img key={index} src={src} alt={slideAlts[index]} />
                ))}
              </div>
              <div className="carousel-dots">
                {slides.map((_, index) => (
                  <span
                    key={index}
                    className={`dot ${currentSlide === index ? "active" : ""}`}
                    onClick={() => setCurrentSlide(index)}
                  ></span>
                ))}
              </div>
            </div>
            {/* Floating Overlay success rate card */}
            <div className="floating-overlay-card">
              <div className="floating-overlay-icon">
                <Target size={22} strokeWidth={2.5} />
              </div>
              <div className="floating-overlay-text">
                <h4>98% Success Rate</h4>
                <p>Student Projects</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
